import { Box } from '@simplywallst/ui-core';

import { CountryFlag } from '@/components/CountryFlag';
import type { ISO2 } from '@/constants/countries';

import { ListingColumn, ListingRow, UniqueSymbol } from './styled';

export type Props = {
  type: 'secondary';
  id: string;
  label: string;
  name: string;
  exchangeCountryIso: ISO2 | null;
  uniqueSymbol: string;
};

export const SecondaryListing = ({
  label,
  exchangeCountryIso,
  uniqueSymbol,
}: Props) => {
  return (
    <ListingRow alignContent="center" data-cy-id={`secondary-listing-${label}`}>
      <ListingColumn displayFlex noWrap alignItem="center">
        <Box minWidth={68} />
        <Box marginRight="x1">
          <CountryFlag countryISO={exchangeCountryIso} />
        </Box>
        <UniqueSymbol>{uniqueSymbol}</UniqueSymbol>
      </ListingColumn>
    </ListingRow>
  );
};
